import Endpoint from "@/utils/endPoint";

const schoolEndpoint = new Endpoint("/schools/{id}");
const schoolIntroEndpoint = new Endpoint("/schools/{id}/introduction");

class SchoolService {
    async getSchoolInfoService(params) {
        const result = await schoolEndpoint.get(params);
        return result;
    }

    async getSchoolIntroService(params) {
        const result = await schoolIntroEndpoint.get(params);
        return result;
    }

    async updateSchoolIntroService(params) {
        const { id, ...param } = params
        const result = await schoolIntroEndpoint.put(param, { id });
        return result;
    }
}

export default new SchoolService();
